import { useState } from 'react';
import { IconDeviceFloppy, IconCamera } from '@tabler/icons-react';
import { showToast } from '../components/ui/Toast';
import { useSiteContent } from '../context/SiteContentContext';
import ImageUploader from '../components/ui/ImageUploader';
import { getPageImage, setPageImage, removePageImage } from '../lib/imageStore';

export default function AdminAbout() {
  const { content, updateBulk } = useSiteContent();
  const [form, setForm] = useState({ ...content });
  const [saved, setSaved] = useState(true);
  const [workshopImg, setWorkshopImg] = useState(getPageImage('about_workshop'));
  const [leatherImg, setLeatherImg] = useState(getPageImage('about_leather'));

  function set(key, value) { setForm(prev => ({ ...prev, [key]: value })); setSaved(false); }
  const [saving, setSaving] = useState(false);
  async function save() {
    if (saving) return;
    setSaving(true);
    const r = await updateBulk(form);
    setSaving(false);
    if (r && r.error) { showToast(r.error, 'error'); return; }
    setSaved(true);
    showToast('About page saved');
  }

  function field(key, label, type = 'input') {
    return (
      <div className="adm-field">
        <label className="adm-label">{label}</label>
        {type === 'textarea' ? (
          <textarea className="adm-textarea" value={form[key] || ''} onChange={e => set(key, e.target.value)} />
        ) : (
          <input className="adm-input" value={form[key] || ''} onChange={e => set(key, e.target.value)} />
        )}
      </div>
    );
  }

  return (
    <div>
      <h1 className="adm-title">About page</h1>
      <p className="adm-sub">Edit your story, photos, values, and craft philosophy.</p>

      <div className="adm-card">
        <div className="adm-card-title">Hero section</div>
        {field('about_hero_eyebrow', 'Eyebrow')}
        {field('about_hero_headline', 'Headline')}
      </div>

      <div className="adm-card">
        <div className="adm-card-title">Story block 1 — Where it began</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 180px', gap: 16 }}>
          <div>
            {field('about_story_1_heading', 'Heading')}
            {field('about_story_1_body', 'Body', 'textarea')}
          </div>
          <div>
            <label className="adm-label" style={{ marginBottom: 6, display: 'block' }}>
              <IconCamera size={12} style={{ verticalAlign: -1 }} /> Workshop photo
            </label>
            <ImageUploader
              image={workshopImg}
              onUpload={(data) => { setPageImage('about_workshop', data); setWorkshopImg(data); }}
              onRemove={() => { removePageImage('about_workshop'); setWorkshopImg(null); }}
              label="Workshop"
            />
          </div>
        </div>
      </div>

      <div className="adm-card">
        <div className="adm-card-title">Story block 2 — The materials</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 180px', gap: 16 }}>
          <div>
            {field('about_story_2_heading', 'Heading')}
            {field('about_story_2_body', 'Body', 'textarea')}
          </div>
          <div>
            <label className="adm-label" style={{ marginBottom: 6, display: 'block' }}>
              <IconCamera size={12} style={{ verticalAlign: -1 }} /> Leather detail
            </label>
            <ImageUploader
              image={leatherImg}
              onUpload={(data) => { setPageImage('about_leather', data); setLeatherImg(data); }}
              onRemove={() => { removePageImage('about_leather'); setLeatherImg(null); }}
              label="Leather detail"
            />
          </div>
        </div>
      </div>

      <div className="adm-card">
        <div className="adm-card-title">Values (3 cards)</div>
        {field('about_value_1_title', 'Value 1 title')}
        {field('about_value_1_body', 'Value 1 description', 'textarea')}
        {field('about_value_2_title', 'Value 2 title')}
        {field('about_value_2_body', 'Value 2 description', 'textarea')}
        {field('about_value_3_title', 'Value 3 title')}
        {field('about_value_3_body', 'Value 3 description', 'textarea')}
      </div>

      <div className="adm-save-bar">
        <span className={`adm-save-status ${saved ? 'adm-save-status--saved' : ''}`}>
          {saved ? '✓ All changes saved' : '● Unsaved changes'}
        </span>
        <button className="adm-btn" onClick={save}><IconDeviceFloppy size={14} /> Save</button>
      </div>
    </div>
  );
}
